export default "/images/logo.png?540b07bfa202ca54ba0e27ab543fea43";